"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableActionFileText_1 = require("../../../../../../shared/components/table_actions/TableActionFileText");
var TableActionFileWord_1 = require("../../../../../../shared/components/table_actions/TableActionFileWord");
var CmsPostRecordsList = /** @class */ (function (_super) {
    __extends(CmsPostRecordsList, _super);
    function CmsPostRecordsList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Название',
                dataIndex: _this.props.data.dk_title,
                key: _this.props.data.dk_title,
                width: 200,
            }, {
                title: 'Категория',
                dataIndex: _this.props.data.dk_post_category_title,
                key: _this.props.data.dk_post_category_title,
                width: 200,
            }, {
                title: 'Язык',
                dataIndex: _this.props.data.dk_app_language_title,
                key: _this.props.data.dk_app_language_title,
                width: 100,
            }, {
                title: 'Дата публикации',
                dataIndex: _this.props.data.dk_post_date2,
                key: _this.props.data.dk_post_date2,
                width: 100,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_changed2.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: 'Опубликовано',
                dataIndex: _this.props.data.dk_is_locked,
                key: _this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    if (record.is_locked) {
                        return (React.createElement("div", null, "\u041D\u0435\u0442"));
                    }
                    else {
                        return (React.createElement("div", null, "\u0414\u0430"));
                    }
                },
                width: 100,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionFileWord_1.default, { hint: "\u0412\u0438\u0437\u0443\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440", onClick: function () { _this.onEditVisualClick(record); } }),
                    React.createElement(TableActionFileText_1.default, { hint: "\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 HTML", onClick: function () { _this.onEditRawClick(record); } }),
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 80
            }
        ];
        return _this;
    }
    CmsPostRecordsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.root.key);
        });
        this.props.state.setExtBreadCrumbPath(["Категории записей", "Список записей"]);
    };
    CmsPostRecordsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    CmsPostRecordsList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                _this.props.data.LoadData(_this.props.root.key);
            });
        }
    };
    CmsPostRecordsList.prototype.onEditVisualClick = function (record) {
        if (this.props.onEditVisualClick) {
            this.props.onEditVisualClick(record);
        }
    };
    CmsPostRecordsList.prototype.onEditRawClick = function (record) {
        if (this.props.onEditRawClick) {
            this.props.onEditRawClick(record);
        }
    };
    CmsPostRecordsList.prototype.onEditClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    CmsPostRecordsList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0417\u0430\u043F\u0438\u0441\u044C ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430"));
        });
    };
    CmsPostRecordsList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.props.data.LoadData(_this.props.root.key, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    CmsPostRecordsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.root.key);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    CmsPostRecordsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { back: "Вернуться", create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", { style: { margin: 0, display: "flex", flexDirection: "row", flexWrap: "nowrap" } },
                        React.createElement("div", { style: {
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                flexWrap: "nowrap"
                            } },
                            React.createElement("div", null,
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                                    " [",
                                    record.key,
                                    "] "),
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                                    " [",
                                    record.date_added2.format(_this.props.state.getDateTimeFormat()),
                                    "] "),
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                                    " [",
                                    record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                                    "]"),
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u041F\u0440\u0435\u0432\u044C\u044E:"),
                                    " [",
                                    record.preview_text,
                                    "]")),
                            React.createElement("div", null,
                                React.createElement("img", { style: { marginLeft: "20px" }, height: 110, src: "" + _this.props.data.DATA.cdn_baseurl + record.cms_image_url })))));
                }, scroll: { x: true } })));
    };
    return CmsPostRecordsList;
}(React.Component));
exports.default = CmsPostRecordsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_posts/ui/component/CmsPostRecordsList.tsx
// module id = 2380
// module chunks = 0